"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslatedText = exports.StaticTextProvider = void 0;
var react_1 = __importStar(require("react"));
/**
 * Utility function to fetch internationalized text using a lookup path.
 *
 * const result = i18nText(['messageGreeting'], testStrings, {
 *     name: 'Bob',
 *     count: '5'
 * }) // ->  'Hello Bob, you have 5 messages'
 *
 * @param keys - Array of keys forming the lookup path (e.g., ['sidebarItem', 'select'])
 * @param lookup - InternationalStrings map containing the translations
 * @param params - Optional parameters for string interpolation (e.g., {name: 'John'})
 * @returns Translated string with parameters interpolated, or the last key as fallback
 */
var i18nText = function (keys, lookup, params) {
    if (params === void 0) { params = {}; }
    if (!lookup || !lookup.getIn || keys.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('i18nText could not find value for key path:', keys);
        return keys[keys.length - 1] || '';
    }
    var template = lookup.getIn(keys, keys[keys.length - 1]);
    // Replace {paramName} patterns with actual values
    return template.replace(/{(\w+)}/g, function (match, param) {
        return params[param] || match;
    });
};
var StaticTextContext = (0, react_1.createContext)(undefined);
var StaticTextProvider = function (_a) {
    var children = _a.children, staticText = _a.staticText;
    return (react_1.default.createElement(StaticTextContext.Provider, { value: { staticText: staticText } }, children));
};
exports.StaticTextProvider = StaticTextProvider;
var useTranslatedText = function (_a) {
    var keys = _a.keys, _b = _a.params, params = _b === void 0 ? {} : _b;
    var context = (0, react_1.useContext)(StaticTextContext);
    if (context === undefined) {
        throw new Error('useStaticText must be used within a StaticTextProvider');
    }
    return i18nText(__spreadArray(['data'], keys, true), context.staticText, params);
};
exports.useTranslatedText = useTranslatedText;
